import axios from 'axios'
export const LOAD_PERFORMERS = 'load_performers'
export const SET_PERIOD = 'set_period'
export const SET_TYPE = 'set_type'
export const SET_LEV_TYPE = 'set_levType'
export const GET_ENTITIES = 'get_entities'
export const SET_TOPN = 'set_topn'
export const SET_FUNDCCY = 'set_fundccy'
export const SET_CURRENCY = 'set_currency'
export const SET_COBDATE = 'set_cobdate'
export const SET_SORT = 'set_sort'
export const SORT_DATA = 'sort_data'
export const SET_TIER1CAT = 'set_tier1cat'
export const SET_TIER2CAT = 'set_tier2cat'
export const FILTER_DATA = 'filter_data'
export const SET_FILTER_WORD = 'set_filterword'
export const RESET_LOAD_STATUS = 'set_loadstatus'

function getParamValue(param) {
  const vars = {}
  window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = decodeURIComponent(value)
  })
  const val = vars[param]
  if (val == null) {
    return null
  } else {
    const values = val.split(',').map((i) => {
      return { value: i }
    })
    return values
  }
}

export function loadPerformers() {
  return (dispatch, getState) => {
    dispatch({ type: RESET_LOAD_STATUS, value: false })
    let cobdate = getState().performers.cobdate
    if (!cobdate) {
      let windowParams = (windowParams = getParamValue('date'))
      if (windowParams) {
        windowParams = getParamValue('date')
        cobdate = windowParams[0].value
      }
    }

    let wtRegion = getState().performers.wtRegion
    let wtDivisionID = getState().performers.wtDivisionID
    let windowRegion = getParamValue('region')

    if (windowRegion && windowRegion[0].value && windowRegion[0].value.toLowerCase() !== 'us') {
      wtRegion = windowRegion[0].value
      wtDivisionID = 2
    }

    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/data?`,

      params: {
        wtRegion: wtRegion,
        wtDivisionID: wtDivisionID,
        isoCode: getState().performers.isoCode,
        cobDate: cobdate,
        topn: getState().performers.topn,
        typeCat: getState().performers.typeCat,
        isFP: getState().performers.isFP,
        currency: getState().performers.selectedCurrencyOption,
        isSL: getState().performers.isSL
      }
    }

    return axios(request)
      .then((response) => {
        console.log('Request', request)
        console.log('Response', response)
        dispatch({ type: LOAD_PERFORMERS, payload: response.data })
        dispatch({ type: GET_ENTITIES })
        dispatch({ type: SET_SORT, column: '' })
        dispatch({ type: SORT_DATA })
        dispatch({ type: RESET_LOAD_STATUS, value: true })
      })
      .catch((error) => {
        console.log(error)
        dispatch({ type: RESET_LOAD_STATUS, value: true })
      })
  }
}

export function setPeriod(period) {
  return (dispatch) => {
    dispatch({ type: SET_PERIOD, payload: period })
    dispatch({ type: GET_ENTITIES })
    dispatch({ type: SORT_DATA })
    saveToGA('PerfPeriod', period)
  }
}

export function setLevType(levType) {
  return (dispatch) => {
    const selectedLevType = levType.value
    dispatch({ type: SET_LEV_TYPE, payload: selectedLevType })
    dispatch(loadPerformers())
    saveToGA('LevType', selectedLevType)
  }
}

export function setType(type) {
  return (dispatch) => {
    dispatch({ type: SET_TYPE, payload: type })
    dispatch({ type: GET_ENTITIES })
    dispatch({ type: SORT_DATA })
    saveToGA('PriceType', type)
  }
}
export function setCurrency(currency) {
  return (dispatch) => {
    dispatch({ type: SET_CURRENCY, payload: currency.value })
    dispatch(loadPerformers())
  }
}

export function setTopN(topn) {
  return (dispatch) => {
    dispatch({ type: SET_TOPN, payload: topn })
    dispatch(loadPerformers())
    saveToGA('TopN', topn.toString())
  }
}

export function setFundCcy(topn) {
  return (dispatch) => {
    dispatch({ type: SET_FUNDCCY, payload: topn })
    dispatch(loadPerformers())
  }
}

export function setTier1Cat(tier1) {
  return (dispatch) => {
    const selected = tier1.map((i) => i.value)
    dispatch({ type: SET_TIER1CAT, payload: selected })
    dispatch(loadPerformers())
    dispatch({ type: SORT_DATA })
    saveToGA('Sub Nav', selected.join('|'))
  }
}

export function setTier2Cat(tier2) {
  return (dispatch) => {
    const selected = tier2.map((i) => i.value)
    dispatch({ type: SET_TIER2CAT, payload: selected })
    dispatch(loadPerformers())
    dispatch({ type: SORT_DATA })
    saveToGA('Sub Nav', selected.join('|'))
  }
}
export function setCobDate(date) {
  return (dispatch) => {
    dispatch({ type: SET_COBDATE, payload: date })
    dispatch(loadPerformers())
    saveToGA('Date', date)
  }
}

export function setSort(column) {
  return (dispatch) => {
    dispatch({ type: SET_SORT, column: column })
    dispatch({ type: SORT_DATA })
  }
}

export function clearFilters() {
  return (dispatch) => {
    dispatch({ type: SET_TIER1CAT, payload: '' })
    dispatch({ type: SET_TIER2CAT, payload: '' })
  }
}

export function saveToGA(eventAction, eventLabel) {
  const e = {
    eventName: 'invtools',
    eventAction: eventAction,
    eventLabel: eventLabel,
    type: 'CustomTagEvent'
  }

  if (window.digitalData) {
    if (e.Label !== '') {
      window.digitalData.newEvent(e)
      console.log('digitalData: ', e)
    }
  } else {
    console.log('no digitalData : ', e)
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js